import { inject, observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

import { modelOf } from '../../../../prop-types';
import ConfigStore from '../../../../store/ConfigStore';
import InfoPageStore from '../../../../store/InfoPageStore';
import RequestState from '../../../../types/RequestState';
import ContentForState from '../../../loader/ContentForState';
import { CheckoutFormBenefitsSkeleton } from '../../../skeleton/CheckoutPageSkeleton';

const CheckoutCustomerBenefits = ({ configStore, infoPageStore }) => {
  useEffect(() => {
    maybeLoadBenefitsInfoPage();
  }, []);

  const maybeLoadBenefitsInfoPage = () => {
    const pageId = configStore.infoPages.customerBenefits;

    if (
      configStore.registration.enabled &&
      pageId &&
      pageId.length > 0 &&
      infoPageStore.pageStates.get(pageId) !== RequestState.LOADED &&
      infoPageStore.pageStates.get(pageId) !== RequestState.ERROR
    ) {
      infoPageStore.loadPage(pageId).catch((e) => {
        if (e.responce && e.responce.status !== 404) {
          console.error(e);
        }
      });
    }
  };

  const getBenefitsState = () => {
    const infoPageId = configStore.infoPages.customerBenefits;

    if (!infoPageId) {
      return RequestState.LOADED;
    }
    if (infoPageStore.pageStates.get(infoPageId) !== RequestState.LOADING) {
      return RequestState.LOADED;
    }
    return infoPageStore.pageStates.get(infoPageId);
  };

  const getDefaultBenefits = () => {
    return (
      <>
        <div className="CheckoutCustomerBenefits__header">
          <FormattedMessage
            id="account.registrationBenefitsHeader"
            defaultMessage="Registration benefits"
          />
        </div>
        <ul className="AccountModal__registration-benefits">
          <li>
            <FormattedMessage
              id="account.registrationBenefitsNewsletterItem"
              defaultMessage="Newsletter - you'll be informed of special offers and campaigns available through our store."
            />
          </li>
          <li>
            <FormattedMessage
              id="account.registrationBenefitsFasterCheckoutItem"
              defaultMessage="Easy and quick checkout - your personal details will be filled in automatically."
            />
          </li>
          <li>
            <FormattedMessage
              id="account.registrationBenefitsOrderHistoryItem"
              defaultMessage="Order history - you'll be able to see the orders you've previously done through our store."
            />
          </li>
          <li>
            <FormattedMessage
              id="account.registrationBenefitsPersistentCartItem"
              defaultMessage="Persistent cart - the items you add to your cart will stay there until you remove them or confirm the order."
            />
          </li>
          <li>
            <FormattedMessage
              id="account.registrationBenefitsWishlistItem"
              defaultMessage="You'll be able to create a wishlist you can then share with your friends."
            />
          </li>
        </ul>
      </>
    );
  };

  const getInfoPage = () => {
    const infoPageId = configStore.infoPages.customerBenefits;

    return infoPageId &&
      infoPageStore.pageStates.get(infoPageId) === RequestState.LOADED
      ? infoPageStore.pages.get(infoPageId)
      : null;
  };

  const getBenefits = () => {
    const infoPage = getInfoPage();
    return infoPage && infoPage.content ? (
      <div
        className="AccountModal__body-content"
        dangerouslySetInnerHTML={{
          __html: infoPage.content,
        }}
      />
    ) : (
      getDefaultBenefits()
    );
  };

  return (
    <Row className='CheckoutCustomerBenefits'>
      <Col xs={12}>
        <ContentForState
          state={getBenefitsState()}
          forPlaceHolder={<CheckoutFormBenefitsSkeleton />}
          forLoaded={() => {
            return getBenefits();
          }}
        />
      </Col>
    </Row>
  );
};

CheckoutCustomerBenefits.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  infoPageStore: modelOf(InfoPageStore).isRequired,
};

export default inject(
  'configStore',
  'infoPageStore'
)(observer(CheckoutCustomerBenefits));
